var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
const claim = namespace('claim');
let ReactivateMagicLinkButton = class ReactivateMagicLinkButton extends Vue {
    async handleClick() {
        var _a;
        const claim = (_a = this.info) === null || _a === void 0 ? void 0 : _a.claim;
        if (!claim)
            return;
        try {
            await this.reactivateMagicLink(claim.caseNumber);
            this.$buefy.toast.open({
                message: this.$tc('magicLink.reactivated'),
                type: 'is-success',
            });
        }
        catch (error) {
            this.$buefy.toast.open({
                message: this.$tc('magicLink.reactivated_error'),
                type: 'is-danger',
            });
        }
    }
};
__decorate([
    claim.State('info')
], ReactivateMagicLinkButton.prototype, "info", void 0);
__decorate([
    claim.Action('reactivateMagicLink')
], ReactivateMagicLinkButton.prototype, "reactivateMagicLink", void 0);
ReactivateMagicLinkButton = __decorate([
    Component
], ReactivateMagicLinkButton);
export default ReactivateMagicLinkButton;
